module.exports = __webpack_public_path__ + "sansg/img/stairway-828883.387ede2a.png";